import { Tab as CTab } from "@chakra-ui/react";

// interface TabProps extends CTabProps {}

const Tab = (props) => {
  return (
    <CTab
      pos="relative"
      p={["20px", "20px 56px"]}
      // pl="0 !important"
      mr="20px"
      // py="16px"
      color="#A0A3BD"
      fontWeight="600"
      fontSize={["sm", "sm"]}
      borderRadius="4px 4px 0px 0px"
      borderBottom="2px solid transparent"
      _focus={{
        shadow: "0 0 0 3px var(--focusColor)",
      }}
      _selected={{
        color: "#0CB24C",
        borderColor: "#0CB24C",
      }}
      {...props}
      borderColor="transparent"
    >
      {props.children}
    </CTab>
  );
};

export default Tab;
